/**
 * Graph mixins to extend component functionality with one codebase
 */

import GraphManager from '../../helpers/GraphManager'
import {TweenMax, Power2, TimelineLite} from 'gsap'
import config from '../../config'


moment.locale(config.language);

export default {
  watch: {
    'userId': function () {
      let self = this;
      self.graph.userId = self.userId;
    }
  },
  methods: {
    applyCustomDate() {
      let self = this;
      self.$emit('graphLoading', true);
      GraphManager.applyCustomDate(self); 
    },
    hideCustomDate: function hideCustomDate() {
      let self = this;
      GraphManager.hideCustomDate(self);
    },
    showCustomDate: function showCustomDate() {
      let self = this;
      GraphManager.showCustomDate(self);
    },
    setToday: function setToday() {
      let self = this;
      GraphManager.setToday(self);
    },
    setDateStep: function setDateStep(step) {
      let self = this;
      /**
       * Dont scroll top for profile page
       */
      let done = null;
      if (self.$route.name !== 'ProfileProgress') {
        const mainContentElement = document.getElementsByClassName('main-content')[0];
        TweenLite.to(mainContentElement, 0.2, {scrollTo: 0});
        let waitForAnimationToComplete = setTimeout(function () {
          done = true;
          GraphManager.setDateStep(self, step);
          clearTimeout(waitForAnimationToComplete)
        }.bind(self), 300)
      }
      else if (done === null && done !== true) {
        GraphManager.setDateStep(self, step)
      }
    },
    dateForward: function dateForward() {
      let self = this;
      GraphManager.dateForward(self)
    },
    dateBackward: function dateBackward() {
      let self = this;
      GraphManager.dateBackward(self);
    },
    graphLoading: function graphLoading() {
      let self = this;
      GraphManager.graphLoading(self);
    },
    graphDidLoad: function graphDidLoad() {
      let self = this;
      GraphManager.graphDidLoad(self);
    },
    graphDidFail: function graphDidFail() {
      let self = this;
      GraphManager.graphDidFail(self);
    },
    humanizeDays: function humanizeDays(days) {
      moment.locale(config.language);
      return moment.duration(days, 'days').humanize();
    },

  },
  computed:{
    showPoints() {
      return this.$store.state.graphOptions.showDots
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('updateGraphData');
    this.$EventBus.$off('updateGraph');
  }
}



// WEBPACK FOOTER //
// ./src/mixins/GraphMixin/index.js